export const NO_ASSETS_FOUND_MESSAGE = 'No Assets Found';
export const COMPUTER_LAB_SETUP_FEEDACK_LINK =
    'https://docs.google.com/forms/d/e/1FAIpQLSfNuJWLgttHrsd4BMTz_QMJUY124I60YrxngFbzTcT0A0Ef9w/viewform?usp=header';
export const ACTIVE_TEACH_HELP_AND_FAQ_URL =
    'https://docs.google.com/document/d/e/2PACX-1vSTXZDVW8UExNAR_9tWkG8TncMrTup41q5bTow5jcp9-sMajVzngajtRtBg7Adwbhsz3TJOhvffKu0b/pub';
export const BUILDR_TEACH_HELP_AND_FAQ_URL =
    'https://docs.google.com/document/d/e/2PACX-1vStUYp7CHkqhF5jeGYeINDLzOKauidQBUNmgPDksW7YYlxrTkgc5eE4jYL-QqN-OoiAUzoXf4AKKG3d/pub';
export const ACTIVE_TEACH_ONBOARDING_VIDEO_LINK =
    'https://static2-tempcdn.leadschool.in/outputvod/hls/atonboarding.m3u8';
export const BUILDR_ONBOARDING_VIDEO_LINK =
    'https://static2-tempcdn.leadschool.in/outputvod/hls/codeaionboardingvideo.m3u8';

export const LEAD_HELP_MAIL_LINK =
    'https://mail.google.com/mail/?view=cm&fs=1&to=help@leadschool.in&su=Support&body=Hi,%20I%20need%20assistance%20with...';

export const LEAD_HELP_MAIL_ID = 'help@leadschool.in';
export const LEAD_HELP_PHONE_NUMBER = '86828 33333';

export const TRAINING_CALENDAR_LINK ='https://drive.google.com/file/d/1R-YEzYy_s91D87ePjdEs-c8eoQA2yQF1/view'
export const TRAINING_SESSIONS_JSON=[
    {
      "id": 2,
      "topic": "Create a Game in Scratch 3.0",
      "date": "22 August 2025",
      "start_time": "11:00 AM",
      "end_time": "12:30 PM"
    },
    {
      "id": 3,
      "topic": "Create a Game in Scratch 3.0",
      "date": "29 August 2025",
      "start_time": "4:00 PM",
      "end_time": "5:30 PM"
    },
    {
      "id": 4,
      "topic": "Learn Advanced Python with AI",
      "date": "5 September 2025",
      "start_time": "11:00 AM",
      "end_time": "12:30 PM"
    },
    {
      "id": 5,
      "topic": "Create a Webpage with HTML & CSS",
      "date": "12 September 2025",
      "start_time": "11:00 AM",
      "end_time": "12:30 PM"
    },
    {
      "id": 6,
      "topic": "Learn Advanced Python with AI",
      "date": "19 September 2025",
      "start_time": "4:00 PM",
      "end_time": "5:30 PM"
    },
    {
      "id": 7,
      "topic": "Create a Webpage with HTML & CSS",
      "date": "26 September 2025",
      "start_time": "4:00 PM",
      "end_time": "5:30 PM"
    },
    {
      "id": 8,
      "topic": "Create a Smart Home System using Machine Learning for Kids",
      "date": "17 October 2025",
      "start_time": "11:00 AM",
      "end_time": "12:30 PM"
    },
    {
      "id": 9,
      "topic": "Create a Smart Home System using Machine Learning for Kids",
      "date": "31 October 2025",
      "start_time": "4:00 PM",
      "end_time": "5:30 PM"
    },
    {
      "id": 10,
      "topic": "Create a Chatbot with Generative AI",
      "date": "7 November 2025",
      "start_time": "11:00 AM",
      "end_time": "12:30 PM"
    },
    {
      "id": 11,
      "topic": "Create a Chatbot with Generative AI",
      "date": "14 November 2025",
      "start_time": "4:00 PM",
      "end_time": "5:30 PM"
    },
    {
      "id": 12,
      "topic": "Explore AutoDraw & QuickDraw",
      "date": "21 November 2025",
      "start_time": "11:00 AM",
      "end_time": "12:30 PM"
    },
    {
      "id": 13,
      "topic": "Explore AutoDraw & QuickDraw",
      "date": "28 November 2025",
      "start_time": "4:00 PM",
      "end_time": "5:30 PM"
    }
  ]
  
  